<template>
  <div class="h-full">
    <!-- <div class="flex mb-10px pt-10px mr-10px">
      <el-button size="small" type="primary" @click="formDialog = true" v-loading="loading"
        >添加</el-button
      >
    </div> -->
    <el-table
      ref="table"
      :data="tableData"
      class="w-full"
      :height="tableHeight"
      v-loading="loading"
    >
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="路径编码"
        prop="code"
        min-width="200"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="疏散路径名称"
        prop="name"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="所属区域"
        prop="areaName"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作" width="80">
        <template slot-scope="scope">
          <!-- <el-button size="mini" @click.native="deleteRow(scope.row.id)">删除</el-button> -->
          <span class="text-rose-500 mr-10px cursor-pointer" @click="deleteRow(scope.row.id)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <EvacuationPathDialog
      v-if="formDialog"
      :dataList="tableData"
      @cancel="formDialog = false"
      @handleOk="handleOk"
    ></EvacuationPathDialog>
  </div>
</template>

<script>
import EvacuationPathDialog from './EvacuationPathDialog'

export default {
  name: 'evacuation-path-table',
  components: {
    EvacuationPathDialog,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formDialog: false,
      tableData: [],
      loading: false,
      total: 0,
    }
  },
  watch: {},
  computed: {
    tableHeight() {
      return 'calc(100% - 80px)'
    },
  },
  created() {
    this.findList()
  },
  mounted() {},
  methods: {
    handleOk(list) {
      this.tableData = [...this.tableData, ...list]
    },
    deleteRow(id) {
      this.tableData = this.tableData.filter((item) => {
        return item.id !== id
      })
    },

    async findList() {
      // const data = {
      //   riskPointType: 0,
      //   maxResultCount: this.pageConfig.MaxResultCount,
      //   skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount,
      //   ...this.searchData,
      // }
      // this.loading = true
      // const [err, res] = await sourcesDangerRecognitionPlanTaskApi.riskPointPagedListQuery(data)
      // if (!err) {
      //   this.tableData = res.items.map((item) => {
      //     item.id = item.riskPointId
      //     item.jobName = item.riskPointName
      //     return item
      //   })
      //   this.total = res.totalCount
      // }
      // this.loading = false
    },
  },
}
</script>

<style></style>
